import CryptoJS from "crypto-js";
import placeHolderLogo from "../images/logo_placeholder.jpg";
import placeHolderCover from "../images/server_generic_cover.jpg";
import { Configuration, OpenAIApi } from "openai";

const API_URL = "https://console.drivebusinessintelligence.com";
let clientDataID = "0000";

function getClientAPI() {
  return "jI4MTE1YmM2ZGJlMzZjN2ZmMmY4OGM4ZGJjNjky=";
}

function generateSignature(): string {
  const clientsAPIKey = getClientAPI();
  const date = new Date().toISOString().substring(0, 10);
  const signature = CryptoJS.MD5(clientsAPIKey + date).toString(
    CryptoJS.enc.Hex
  );
  return signature;
}

function localSignature() {
  const dcxLocalClient = JSON.parse(
    localStorage.getItem("DCXCliSig") || "null"
  );
  let existingSignature = null;

  if (dcxLocalClient !== null) {
    existingSignature = dcxLocalClient.signature;

    if (existingSignature !== null) {
      return existingSignature;
    } else {
      existingSignature = generateSignature();
    }

    dcxLocalClient.signature = existingSignature;
    localStorage.setItem("DCXCliSig", JSON.stringify(dcxLocalClient));
  } else {
    existingSignature = generateSignature();
    localStorage.setItem(
      "DCXCliSig",
      JSON.stringify({ signature: existingSignature })
    );
  }
  return existingSignature;
}

export function ClientCoverImage(urlClientID: string): string {
  const imageUrl = `${API_URL}/setup/stream_page_logo.php?PAGE=eec_weekly&ID=${urlClientID}`;
  const placeHolder = placeHolderCover;
  return imageUrl || placeHolder;
}

export function ClientLogoImage(urlClientID: string): string {
  const imageUrl = `${API_URL}/setup/stream_logo.php?ID=${urlClientID}`;
  const placeHolder = placeHolderCover;
  return imageUrl || placeHolder;
}

export async function ClientFetch(urlClientID: string): Promise<any> {
  clientDataID = urlClientID;
  const postData = {
    ApiURL: API_URL,
    ApiEndpoint: "api/client/fetch_account_info",
    ClientId: urlClientID,
    Signature: await localSignature()
  };
  const reqURL = `${postData.ApiURL}/${postData.ApiEndpoint}?ClientID=${postData.ClientId}&Signature=${postData.Signature}`;

  const data = await fetchData(postData, reqURL);
  return data;
}

async function fetchData(postData: any, reqURL: string): Promise<any> {
  try {
    const response = await fetch(reqURL, { method: "POST" });
    const { Client } = await response.json();
    return Client;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function RecordDCXCustomer(
  clientID: string,
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
  locationID: string
): Promise<any> {
  const postData = {
    ApiURL: API_URL,
    ApiEndpoint: "api/survey/record_customer",
    ClientId: clientID,
    Signature: localSignature(),
    FirstName: firstName,
    LastName: lastName,
    LocationID: locationID,
    Email: email,
    Phone: phone
  };
  const recordCustomerUrl = `${postData.ApiURL}/${postData.ApiEndpoint}?ClientID=${postData.ClientId}&LocationID=${postData.LocationID}&FirstName=${postData.FirstName}&LastName=${postData.LastName}&Email=${postData.Email}&Phone=${postData.Phone}&Signature=${postData.Signature}`;

  // dev @ localhost
  /* if (window.location.hostname === "localhost") {
    console.log("No Recording, localhost");
  } else {
     console.log("Saving new customer with data: " + JSON.stringify(postData));
     const response = await recordNewCustomer(recordCustomerUrl, postData);
     return response;
   } */

  const response = await recordNewCustomer(recordCustomerUrl, postData);
  return response;
}

async function recordNewCustomer(url: string, postData: any): Promise<any> {
  try {
    const response = await fetch(url, { method: "POST" });
    const Client = await response.json();
    console.log(
      Client.Success
        ? `New client's customer created ID: ${Client.ClientCustomerID}`
        : `Unable to create customer: ${Client.ErrorMessage}`
    );
    return Client.ClientCustomerID;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function SendCCard(
  urlClientID: string,
  locationID: string,
  clientCustomerID: string,
  phone: string
): Promise<any> {
  const signature = localSignature();
  const sendCCardURL = `${API_URL}/api/survey/send_link_to_full_survey?ClientID=${urlClientID}&Signature=${signature}&LocationID=${locationID}&ClientCustomerID=${clientCustomerID}&Phone=${phone}`;
  try {
    console.log("Trying to send", sendCCardURL);
    const response = await fetch(sendCCardURL, { method: "POST" });
    const { Client } = await response.json();
    return Client;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function GetClientAPIK(urlClientID: string): Promise<any> {
  const postData = {
    ApiURL: API_URL,
    ApiEndpoint: "/api/register/fetch_api_key",
    ClientId: urlClientID,
    Signature: localSignature()
  };
  const requestUrl = `${postData.ApiURL}/${postData.ApiEndpoint}?ClientID=${postData.ClientId}&Signature=${postData.Signature}`;
  try {
    const response = await fetch(requestUrl, { method: "POST" });
    const { Client } = await response.json();
    return Client;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export function defaultClientData(): Record<string, string> {
  return {
    logoURL: placeHolderLogo,
    coverURL: placeHolderCover,
    clientID: clientDataID,
    locationID: "",
    dcxClientName: "dcxClientName",
    textTitle: "Who am I helping today?",
    textTitle2: "We can help!",
    textSubTitle: "Who we are helping today?",
    textSubTitle2: "Let's Talk!"
  };
}

export async function aiDeptChoose(helPreq: string) {
  return GetAIDepartment(helPreq);
}

async function GetAIDepartment(searchRequest: string): Promise<any> {
  const configuration = new Configuration({
    apiKey: "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"
  });
  const openai = new OpenAIApi(configuration);
  let hostServerURL = window.location.hostname;
  hostServerURL === "localhost"
    ? (hostServerURL = "http://localhost:8081")
    : (hostServerURL = "https://" + window.location.hostname);
  const url = new URL(window.location.href);
  const urlClientID = url.searchParams.get("ClientID") as string;
  const urlLocationID = url.searchParams.get("LocationID") as string;
  const departmentsListURL = `${hostServerURL}/departments?clientId=${encodeURIComponent(
    urlClientID
  )}&locationId=${encodeURIComponent(urlLocationID)}`;
  let clientDepartmentsNames = "";
  let aiSuggestedDepartment = "";

  try {
    const response = await fetch(departmentsListURL, { method: "GET" });
    if (response.ok) {
      const clientDepartmentsData = await response.json();
      if (clientDepartmentsData.length <= 0) {
        const departmentsListURL = `${hostServerURL}/departments?clientId=${encodeURIComponent(
          9999
        )}&locationId=${encodeURIComponent(9999)}`;
        const response = await fetch(departmentsListURL, { method: "GET" });
        if (response.ok) {
          const clientDepartmentsData = await response.json();
        }
      }
      clientDepartmentsNames = clientDepartmentsData.data.map(
        (item: { dptName: any }) => item.dptName
      );
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    console.error(error);
  }

  const searchQuery = `A customer in a retail store asked the following: Where can I find a: ${searchRequest}. The store has the following, and only, these departments: ${clientDepartmentsNames}. Which department should the question be routed to? Just give me the name of the department, no other text.`;

  try {
    const { data } = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: searchQuery,
      temperature: 0,
      max_tokens: 64,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0
    });

    if (
      data.choices &&
      data.choices.length > 0 &&
      data.choices[0].text !== undefined
    ) {
      aiSuggestedDepartment = data.choices[0].text.trim();
    }
  } catch (error) {
    console.error(error);
  } finally {
    return aiSuggestedDepartment;
  }
}

export async function createDBUser(dcxClientCustomer: {
  dcxCustomerId: any;
  name: string;
  email: string;
  phone: string;
}) {
  const newUserUrl = `/new-user`;

  try {
    const response = await fetch(newUserUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dcxClientCustomer)
    });

    const appUser = await response.json();

    if (appUser.errors) {
      console.warn("AppUser DB Not created");
    } else {
      console.log("MySQL Created User: ", appUser);
      return appUser;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function updateDBUser(userIdentifiers: {
  userId: any;
  dcxId: string;
}) {
  const updateUserUrl = `${process.env.REACT_APP_LOCALHOST}/update-user`;

  try {
    const response = await fetch(updateUserUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userIdentifiers)
    });

    const appUser = await response.json();

    if (appUser.errors) {
      console.log("Error: App User Not updated");
    } else {
      console.log("MySQL DcxId User Updated with", userIdentifiers.dcxId);
    }

    return appUser;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function getDBUser(phone: string): Promise<any> {
  const requestUrl = `/get-user?Phone=${phone}`;
  try {
    const response = await fetch(requestUrl, { method: "POST" });
    const getUser = await response.json();
    return getUser.appUser;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function saveDBHRequest(data: any) {
  try {
    const response = await fetch("/new-help", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ hRequest: data })
    });
    const result = await response.json();
    console.log("Save result:", result);
    return result;
  } catch (error) {
    console.error("Error saving HRequest:", error);
  }
}

export async function getDBHRequest(hrId: any): Promise<any> {
  const requestUrl = `/get-help?hrid=${hrId}`;
  try {
    const response = await fetch(requestUrl, { method: "POST" });
    const helpRequest = await response.json();
    return helpRequest;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
